import { Modal, Button, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import React from "react";
import { useRestoreStorageMutation } from "@me-team/host/main/warehouses/graphql/warehouses.hooks";
import { WearhousesModalProps } from "../../modals/modalsUtils";
import { useParams } from "react-router-dom";
import { useRoleAccess } from "@me-team/host/src/utils/useRoleAccess";
import { CompanyAccess } from "@me-team/host/main/graphql/types";

const RestoreWarehouseModal: React.FC<WearhousesModalProps & { canDeleteRestoreWarehouse?: boolean }> = ({
    show,
    handleModal,
    warehouse,
    refetch,
    toggleShowToast,
    canDeleteRestoreWarehouse,
}) => {
    const { t } = useTranslation();
    const { branchId } = useParams();
    const canDeleteRestoreWarehouseByRole = useRoleAccess(CompanyAccess.WarehouseDeleteRestore);
    const canSubmit = canDeleteRestoreWarehouse ?? canDeleteRestoreWarehouseByRole;
    const [restoreStorage, { loading }] = useRestoreStorageMutation({
        context: {
            errorType: "local",
        },
    });

    const handleSubmit = async () => {
        if (!canSubmit) return;

        try {
            await restoreStorage({
                variables: {
                    storageId: warehouse.id,
                    input: {
                        name: warehouse?.name,
                        storageType: warehouse?.type.id,
                        description: warehouse?.description || null,
                    },
                    branchId: Number(branchId),
                },
            });
            refetch();
            toggleShowToast(t("Restored"));
        } catch (error) {
            const graphQLError = error.graphQLErrors?.[0].extensions.validation[""][0].message;
            console.error(graphQLError);
        }
    };

    return (
        <Modal show={show} onHide={handleModal} centered>
            <Modal.Header className="border-0" closeButton>
                <h5 className="m-0">{t("Restore warehouse")}</h5>
            </Modal.Header>
            <Modal.Body>
                <div className="text-center px-3">
                    {t("warehouseRestoreMessage", {
                        warehouseName: warehouse?.name,
                    })}
                </div>

                <Row className="mt-3 g-3">
                    <Col xs={6}>
                        <Button
                            variant="outline-primary"
                            className="fw-normal custom-btn rounded-1 w-100"
                            onClick={handleModal}
                        >
                            {t("Cancel")}
                        </Button>
                    </Col>
                    <Col xs={6}>
                        <Button
                            onClick={handleSubmit}
                            variant="primary"
                            className="fw-bold custom-btn rounded-1 w-100"
                            disabled={loading || !canSubmit}
                        >
                            {t("Restore")}
                        </Button>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
};

export default RestoreWarehouseModal;
